module.exports = [{"value":"แจ้งเตือนประเมินความเสี่ยง","text":"แจ้งเตือนประเมินความเสี่ยง"},{"value":"แจ้งเตือนขอความช่วยเหลือ","text":"แจ้งเตือนขอความช่วยเหลือ"},{"value":"แจ้งเตือนลงทะเบียนผู้ป่วยโควิด","text":"แจ้งเตือนลงทะเบียนผู้ป่วยโควิด"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/covid/notifyType.json
// module id = yc4r
// module chunks = 2